import { type AiMessageResponse } from "@clientFrontend/features/scout/components/PremiumScoutMessageArea/type";
/**
 * AI メッセージを取得する API 呼び出し関数
 * @param createTextUrl API の URL
 * @returns AI メッセージのレスポンス
 * @throws エラーレスポンスの場合はエラーを throw する
 */
export async function fetchAiMessage(createTextUrl: string): Promise<AiMessageResponse> {
  const response = await fetch(createTextUrl);
  if (!response.ok) {
    throw new Error(`Fetch error: ${response.statusText}`);
  }
  const data = await response.json();
  return data as AiMessageResponse;
}
